export default __webpack_public_path__ + "static/media/redmi6.b67cded9.jpg";